import React, { useEffect, useState } from "react";
import { salaryService } from "../../../../api/services/salaryService";
import { setPreviousEmployeeAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/previousAllowanceSlice";
import { setPreviousEmployeeOtherAllowance } from "../../../../infra/aggregates/myProfile/salaryAggregates/previousOtherAllowanceSlice";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";

interface PropsValues {
  setAllPrevAllowances: (data: any) => void;
  setAllPrevAdditionalBenefits: (data: any) => void;
  setCurrency: (data: any) => void;
}

function DTOSalaryHistory({
  setAllPrevAllowances,
  setAllPrevAdditionalBenefits,
  setCurrency,
}: PropsValues) {
  const emp_id: number = useAppSelector((state) => state.authSlice.emp_id);
  const current_currency = useAppSelector((state) => state.authSlice.currency);
  const dispatch = useAppDispatch();

  const storePrevAllowance = useAppSelector(
    (state) => state.previousAllowanceSlice.previousAllowance
  );
  const storePrevOtherAllowance = useAppSelector(
    (state) => state.previousOtherAllowanceSlice.previousOtherAllowance
  );

  async function getSalaryHistory(empId: number) {
    const response: any = await salaryService.getEmployeeCurrentSalary(empId);

    if (response.response == "success") {
      if (response?.data[0]?.prev_salary_allowance) {
        dispatch(
          setPreviousEmployeeAllowance(response?.data[0]?.prev_salary_allowance)
        );
        setAllPrevAllowances(response?.data[0]?.prev_salary_allowance);
      }
      if (response?.data[0]?.prev_other_allowance) {
        dispatch(
          setPreviousEmployeeOtherAllowance(
            response?.data[0]?.prev_other_allowance
          )
        );
        setAllPrevAdditionalBenefits(response?.data[0]?.prev_other_allowance);
        setCurrency(current_currency);
      }
    }
  }

  useEffect(() => {
    getSalaryHistory(emp_id);
  }, []);

  useEffect(() => {
    setAllPrevAllowances(storePrevAllowance);
    setAllPrevAdditionalBenefits(storePrevOtherAllowance);
    setCurrency(current_currency);
  }, [storePrevAllowance, storePrevOtherAllowance]);

  return <></>;
}
export default DTOSalaryHistory;
